<template>
  <sui-page>
    <sui-page-header
      :pageId="this.$options.name"
    />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              :customMdList="codes.allOption"
              :customSmdList="codes.allOption"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="comboPrgType"
              :selected="frame0.selectData.COD_PRG_TYPE"
              :pageId="this.$options.name"
              codeId="COD_PRG_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TECHN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="comboPrgTechn"
              :selected="frame0.selectData.COD_PRG_TECHN"
              :pageId="this.$options.name"
              codeId="COD_PRG_TECHN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="comboUseYn"
              :selected="frame0.selectData.COD_DTSVC_USE_YN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <sui-code-select
              ref="comboPrgSrchCond"
              :selected="frame0.selectData.COD_PRG_SEARCH_COND"
              :pageId="this.$options.name"
              codeId="COD_PRG_SEARCH_COND"
              :customOpitonList="codes.allOption"
              :initialSelectedIndex="0"
              style="width:58%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="frame0.selectData.codPrgSearchText"
              maxlength="100"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMS_00006'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <!-- <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_PRG_LIST") }}</h4>
      </div> -->
      <sui-grid
        ref="listGrid"
        :columns="gridColumns"
        :dataset="'dsPrgLst'"
        :showDisplayCountControl="false"
        :multiselect="true"
        :enabletooltips="true"
        :initialPagesize="10"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="'PGE_CMS_00006'"
            type="button"
            class="comm_btn_gridTop  comm_ico_excel"
            @click="onDownloadExcel"
          >
            {{ $t("MSG_BTN_EXCEL_DOWN") }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:update="'PGE_CMS_00006'"
          type="button"
          class="comm_btn_border"
          @click="onModClick"
        >
          {{ $t("MSG_BTN_MDFC") }}
        </sui-button>
        <sui-button
          v-permission:delete="'PGE_CMS_00006'"
          type="button"
          class="comm_btn_border"
          @click="onDelClick"
        >
          {{ $t("MSG_BTN_DEL") }}
        </sui-button>
        <sui-button
          v-permission:create="'PGE_CMS_00006'"
          type="button"
          class="comm_btn_solid"
          @click="onNewClick"
        >
          {{ $t("MSG_BTN_RGST") }}
        </sui-button>
      </div>
      <sui-popup
        v-model="isShownPopupNew"
        :title="$t('MSG_TXT_PRG_RGST')"
      >
        <p01
          :pageId="this.$options.name"
          @onNewClick="onNewClick"
          @close="popNewClose()"
          @saveClose="popNewSaveClose()"
        />
      </sui-popup>
      <sui-popup
        v-model="isShownPopupMod"
        :title="$t('MSG_TXT_PRG_MDFC')"
      >
        <p02
          :pageId="this.$options.name"
          :programId="frame0.seltProgramId"
          @onModClick="onModClick"
          @close="popModClose()"
          @saveClose="popModSaveClose()"
        />
      </sui-popup>
      <sui-popup
        v-model="isShownPopupDetail"
        :title="$t('MSG_TXT_PRG_DTL')"
      >
        <p03
          :pageId="this.$options.name"
          :programId="frame0.seltProgramId"
          @close="popDetailClose()"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

import p01 from './components/PGE_CMS_00006_P01';
import p02 from './components/PGE_CMS_00006_P02';
import p03 from './components/PGE_CMS_00006_P03';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];

export default {
  name: 'PGE_CMS_00006', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
    p02,
    p03,
  },
  extends: BasePage,
  data() {
    return {
      pageName: 'PGE_CMS_00006',
      codes: CommonConstants.selectOptions(),
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_PRG_TYPE: {
            label: '',
            key: '',
          },
          COD_PRG_TECHN: {
            label: '',
            key: '',
          },
          COD_DTSVC_USE_YN: {
            label: '',
            key: '',
          },
          COD_PRG_SEARCH_COND: {
            label: '',
            key: '',
          },
          codPrgSearchText: '',
        },
      },
      isShownPopupNew: false,
      isShownPopupMod: false,
      isShownPopupDetail: false,
      seltProgramId: '',
      localdata0: [],
      gridColumns: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_PRG_ID'),
        datafield: 'programId',
        // cellclassname: 'BL_textlink',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
          }, this.dsPrgLst, this.$refs.listGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PRG_NM'),
        datafield: 'programName',
        // cellclassname: 'BL_textlink',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
          }, this.dsPrgLst, this.$refs.listGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'programTypeName',
      }, {
        text: this.$t('MSG_TXT_TECHN'),
        datafield: 'programTechnName',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'programUseYn',
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserId',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
          }, this.dsPrgLst, this.$refs.listGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
      }],
      gridColumns1: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
      }, {
        text: this.$t('MSG_TXT_PRG_ID'),
        datafield: 'programOrgId',
      }, {
        text: this.$t('MSG_TXT_PRG_NM'),
        datafield: 'programOrgName',
      }, {
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'programTypeName',
      }, {
        text: this.$t('MSG_TXT_TECHN'),
        datafield: 'programTechnName',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'programUseYn',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userName',
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
      }],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  datasets: [{
    id: 'dsPrgLst',
    type: 'local',
    data: 'localdata0',
    datafields: [
      {
        name: 'moduleName',
        type: 'string',
        map: 'moduleName',
      }, {
        name: 'subModuleName',
        type: 'string',
        map: 'subModuleName',
      }, {
        name: 'programId',
        type: 'string',
        map: 'programId',
      }, {
        name: 'programName',
        type: 'string',
        map: 'programName',
      }, {
        name: 'programTypeName',
        type: 'string',
        map: 'programTypeName',
      }, {
        name: 'programTechnName',
        type: 'string',
        map: 'programTechnName',
      }, {
        name: 'programUseYn',
        type: 'string',
        map: 'programUseYn',
      }, {
        name: 'finalModificationUserId',
        type: 'string',
        map: 'finalModificationUserId',
      }, {
        name: 'finalModificationDTM',
        type: 'string',
        map: 'finalModificationDTM',
      }, {
        name: 'displayLanguageId',
        type: 'string',
        map: 'displayLanguageId',
      }, {
        name: 'knoxId',
        type: 'string',
        map: 'knoxId',
      }, {
        name: 'userName',
        type: 'string',
        map: 'userName',
      }, {
        name: 'userGlobalName',
        type: 'string',
        map: 'userGlobalName',
      }, {
        name: 'departmentName',
        type: 'string',
        map: 'departmentName',
      }, {
        name: 'departmentEnglishName',
        type: 'string',
        map: 'departmentEnglishName',
      }],
  }],
  methods: {
    onResetClick() {
      // this.$refs.smComboFrame0.reset();
      this.$refs.smComboFrame0.selectMd('ALL');
      this.$refs.comboPrgType.reset();
      this.$refs.comboPrgTechn.reset();
      this.$refs.comboUseYn.reset();
      this.$refs.comboPrgSrchCond.reset();
      this.frame0.selectData.codPrgSearchText = '';
    },
    onSearchClick() {
      const codeValue = this.frame0.selectData;
      const queryParams = {
        moduleCode: utils.trim(codeValue.COD_MDLE.key) || '',
        subModuleCode: utils.trim(codeValue.COD_SMDLE.key) || '',
        programTypeCode: utils.trim(codeValue.COD_PRG_TYPE.key) || '',
        programTechnCode: utils.trim(codeValue.COD_PRG_TECHN.key) || '',
        programUseYn: utils.trim(codeValue.COD_DTSVC_USE_YN.key) || '',
        searchCond: utils.trim(codeValue.COD_PRG_SEARCH_COND.key) || '',
        searchWord: utils.trim(this.frame0.selectData.codPrgSearchText) || '',
      };

      http.request(this.$options.name, 'DTS_CMS_00020', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);

        utils.forEach(res.data, item => {
          utils.forEach(item, (values, key) => {
            if (key === 'programId' || key === 'programName') {
              // eslint-disable-next-line no-param-reassign
              item[key] = [{ key: values, label: values, type: 'sublink' }];
            }
          });
        });

        this.localdata0 = res.data;
        this.dsPrgLst.setRawData(this.localdata0);
      }).catch(error => {
        console.log(error);
      });
    },
    onDownloadExcel() {
      const metaObj = {
        // "headerTitle" : {
        //   "codeName" : this.$t('MSG_TXT_CODE_NAME'),
        //   "codeEngName" : this.$t('MSG_TXT_CODE_ENAME'),
        //   "codeAbb" : this.$t('MSG_TXT_ABBR'),
        // },
        headerFontSize: 16,
        headerFontColor: 1,
        headerForegroundColor: 22,
      };

      const sPageId = this.$options.name;
      const objGridColumns = this.gridColumns1;
      const objGridDataset = this.dsPrgLst;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `program-list_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, metaObj);
    },
    onNewClick() {
      this.isShownPopupNew = !this.isShownPopupNew;
    },
    onModClick() {
      // const programId = this.dsPrgLst.getSelectedRow().programId;
      const selectedIndexes = this.dsPrgLst.getSelectedIndexes();
      const rowNum = 1;

      if (selectedIndexes.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_MOD_NO_DATA'));
        return false;
      }

      if (selectedIndexes.length > 1) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_MOD_ONE_CHK'), rowNum));
        return false;
      }

      // this.frame0.seltProgramId = this.dsPrgLst.getSelectedRow().programId;
      this.frame0.seltProgramId = this.dsPrgLst.data[selectedIndexes].programId[0].key;
      this.isShownPopupMod = !this.isShownPopupMod;

      return null;
    },
    onDelClick() {
      const selectedIndexes = this.dsPrgLst.getSelectedIndexes();
      const programIdList = [];

      if (selectedIndexes.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        return false;
      }

      utils.forEach(selectedIndexes, index => {
        programIdList.push(this.dsPrgLst.data[index].programId[0].key);
      });

      utils.messageBox('confirm', this.$t('MSG_ALT_IS_DEL_DATA'), null, () => {
        http.request(this.$options.name, 'DTS_CMS_00024', {
          query: {
            programIdList: utils.join(programIdList, '|'),
          },
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'), null, this.onSearchClick);
        }).catch(error => {
          console.log(error);
        });
      });

      return null;
    },
    onGridButtonClicked(btn, dataRow) {
      console.log(btn, dataRow);
      this.frame0.seltProgramId = dataRow.programId[0].key;
      this.isShownPopupDetail = !this.isShownPopupDetail;
    },
    popNewClose() {
      this.isShownPopupNew = !this.isShownPopupNew;
      // this.onSearchClick();
    },
    popNewSaveClose() {
      this.isShownPopupNew = !this.isShownPopupNew;
      this.onSearchClick();
    },
    popModClose() {
      this.isShownPopupMod = !this.isShownPopupMod;
      // this.onSearchClick();
    },
    popModSaveClose() {
      this.isShownPopupMod = !this.isShownPopupMod;
      this.onSearchClick();
    },
    popDetailClose() {
      this.isShownPopupDetail = !this.isShownPopupDetail;
    },
  },
};
</script>
<style scoped>
</style>
